export const mapIndexesToOrder = <TItem extends { order: number }>(
  items: TItem[]
): TItem[] => items.map((item, index) => ({ ...item, order: index }));
